import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Outlet, useLocation } from 'react-router-dom'
import { Col, Layout, Row, Spin } from 'antd'

import BonLookLogo from 'src/modules/shared/BonLookLogo'
import { isMobile } from 'src/utils/helper'

const { Content, Header } = Layout

const HeaderSection = (): JSX.Element => {
  return (
    <Header className="default-layout__header">
      <Row
        justify={isMobile() ? 'start' : 'center'}
        align="middle"
        gutter={isMobile() ? 24 : 0}
      >
        <Col xs={12} sm={8} className="text-centered">
          <BonLookLogo />
        </Col>
      </Row>
    </Header>
  )
}

const LayoutPlain = (): JSX.Element => {
  const { t } = useTranslation()

  const [, setCollapse] = useState(true)
  const location = useLocation()
  useEffect(() => {
    if (isMobile()) {
      setCollapse(true)
    }
  }, [location])

  return (
    <>
      <HeaderSection />
      <Layout className="default-layout__content" hasSider={true}>
        <Content>
          <React.Suspense
            fallback={
              <Spin
                spinning={true}
                className="default-layout__spinner"
                tip={t('common:loading')}
              />
            }
          >
            <Row justify="center">
              <Col xs={24} sm={10}>
                <Outlet />
              </Col>
            </Row>
          </React.Suspense>
        </Content>
      </Layout>
    </>
  )
}

export default LayoutPlain
